module.exports = __webpack_public_path__ + "img/zewo-logo.6509e7c.svg";